export default {
  title: '404',
  subtitle: 'Looks like you’re lost',
  text: 'The page you are looking for not available!',
  textAside: 'Perfectly crafted mobile and web applications.'
}
